import { lessThan24Hours } from "shared/helpers/functional";
import { dissoc } from "ramda";
import * as types from "store/editSession/editSessionTypes";

// All reducers and saga dispatches are prefixed with SESSION_EDIT

/** Single Participant Editing
 * Step 1: Less than 24 hours ask honorarium charge option
 *           If box is unchecked disable next button
 * Step 2: Determine action (cancel vs ask for reschedule)
 * Step 3: Review Schedule component
 * Step 4: Message Component
 **/

const initialState = {
  chosenAction: "", // user's choice of progression in Step 2
  finalStep: false, // determine showing send vs next
  firstStep: null,
  selectAll: false,
  activeSlot: null, // used for single session edit
  canProgress: true, // is used to determine if next or send should be enabled
  currentStep: null,
  loading: true,
  chosenTimeSlotsById: {},
  completionsWarningOpen: false,
  acceptedAdditionalCharge: false,
  availableSteps: [
    // The various business logic components and their general order of progression
  ],
  messagePaneState: {
    message: "",
    bccEmails: [],
    validEmails: true,
  },
  templateReceived: false,
  isSending: false,
};

const getNextStep = (state, direction) => {
  const stepIndex = state.availableSteps.indexOf(state.currentStep);
  const nextOrPreviousStepIndex =
    direction === "next" ? stepIndex + 1 : stepIndex - 1;
  return state.availableSteps[nextOrPreviousStepIndex];
};

const toggleTimeSlot = (state, { timeSlotId, remove }) => {
  if (remove) {
    return dissoc(timeSlotId, state.chosenTimeSlotsById);
  }

  return { ...state.chosenTimeSlotsById, [timeSlotId]: timeSlotId };
};

const editSessionReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.SEND_SINGLE_SESSION_RESCHEDULE_MESSAGE:
      return {
        ...state,
        isSubmitting: true,
        isSending: true,
      };
    case types.SESSION_EDIT_SINGLE_OPEN: {
      // lessThan24Hours = moment

      const step = lessThan24Hours(action.payload.slot.startTime)
        ? "charge-option"
        : "choose-action";
      return {
        ...state,
        activeSlot: action.payload.slot,
        currentStep: step,
        firstStep: step,
        availableSteps: [
          "charge-option",
          "choose-action",
          "message-pane",
          "review-schedule",
        ],
      };
    }
    case types.SESSION_EDIT_MULTIPLE_OPEN:
      return {
        ...state,
        currentStep: "choose-action",
        firstStep: "choose-action",
        availableSteps: ["choose-action", "schedule-list", "message-pane"],
      };
    case types.SESSION_EDIT_STEP:
      return { ...state, chosenStep: action.payload };
    case types.SESSION_EDIT_CHOOSE_ACTION:
      return { ...state, chosenAction: action.payload };
    case types.SESSION_EDIT_NEXT: {
      const nextStep = getNextStep(state, "next");
      return {
        ...state,
        currentStep: nextStep,
        finalStep: nextStep === "message-pane",
      };
    }
    case types.SESSION_EDIT_BACK: {
      const prevStep = getNextStep(state, "back");
      return {
        ...state,
        currentStep: prevStep,
        chosenAction: "",
        finalStep: false,
        messagePaneState: initialState.messagePaneState,
      };
    }
    case types.SEND_SINGLE_SESSION_RESCHEDULE_MESSAGE_SUCCEEDED:
    case types.SEND_MULTI_SESSION_RESCHEDULE_MESSAGE_SUCCEEDED:
    case types.SESSION_EDIT_MULTIPLE_TOGGLE:
    case types.SESSION_EDIT_SINGLE_TOGGLE:
      return initialState;
    case "SEND_SINGLE_SESSION_RESCHEDULE_MESSAGE_FAILED":
      return {
        ...state,
        isSubmitting: false,
        isSending: false,
      };
    case types.UPDATE_MESSAGE_PANE_STATE:
      return {
        ...state,
        messagePaneState: { ...state.messagePaneState, ...action.payload },
      };
    case types.SESSION_EDIT_TOGGLE_COMPLETION_WARNING:
      return {
        ...state,
        completionsWarningOpen: !state.completionsWarningOpen,
      };
    case types.SESSION_EDIT_ADDITIONAL_CHARGE_TOGGLE:
      return {
        ...state,
        acceptedAdditionalCharge: !state.acceptedAdditionalCharge,
      };
    case types.SESSION_EDIT_TOGGLE_TIMESLOT:
      return {
        ...state,
        chosenTimeSlotsById: toggleTimeSlot(state, action.payload),
      };
    case types.SESSION_EDIT_TOGGLE_SELECT_ALL:
      return { ...state, ...action.payload };
    case types.TOGGLE_TIMESLOT_MODAL: {
      return { ...state, chosenAction: "", exampleEmail: "" };
    }
    case types.CLOSE_TEMPLATE: {
      return { ...state, exampleEmail: "", templateReceived: false };
    }
    case types.GET_EMAIL_TEMPLATE_SUCCEEDED:
      return {
        ...state,
        action,
        exampleEmail: action.exampleEmail,
        isSubmitting: false,
        templateReceived: true,
      };
    case types.GET_INVALIDATE_INTERVIEW_EMAIL_TEMPLATE_SUCCEEDED:
      return {
        ...state,
        action,
        exampleEmail: action.exampleEmail,
        isSubmitting: false,
        templateReceived: true,
      };
    case types.GET_EMAIL_TEMPLATE_REQUESTED:
      return {
        ...state,
        action,
        exampleEmail: action.exampleEmail,
        isSubmitting: true,
        templateReceived: false,
      };
    case types.GET_INVALIDATE_INTERVIEW_EMAIL_TEMPLATE_REQUESTED:
      return {
        ...state,
        action,
        exampleEmail: action.exampleEmail,
        isSubmitting: true,
        templateReceived: false,
      };
    case types.GET_EMAIL_TEMPLATE_FAILED:
      return {
        ...state,
        action,
        exampleEmail: action.exampleEmail,
        isSubmitting: false,
        templateReceived: false,
      };
    case types.GET_INVALIDATE_INTERVIEW_EMAIL_TEMPLATE_FAILED:
      return {
        ...state,
        action,
        exampleEmail: action.exampleEmail,
        isSubmitting: false,
        templateReceived: false,
      };
    // Submission spinner specifically for invalidate/send flows
    case "INVALIDATE_INTERVIEW_REQUESTED":
      return {
        ...state,
        isSubmitting: true,
        isSending: true,
      };
    case "INVALIDATE_INTERVIEW_SUCCEEDED":
    case "INVALIDATE_INTERVIEW_FAILED":
      return {
        ...state,
        isSubmitting: false,
        isSending: false,
      };
    default:
      return state;
  }
};

export default editSessionReducer;
